import React from 'react';
import styled from 'styled-components';
import SearchFromTheList from '../../../../../generic/customSearchComponents/SearchFromTheList';
import SearchWarehouse from '../../knisot/Create/Components/SearchWarehouse';
import { useTranslation } from 'react-i18next';
import ControlButton from '../../../../../generic/buttons/ControlButton';
import SearchBlockWithTitle from '../../procedures/Q8/Layouts/SearchBlockWithTitle';
import SearchInput from '../../../../../generic/inputs/inputSearch';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  height: 100%;
  padding: 0 1rem;
`;
const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  height: 100%;
  padding: 0 1rem;
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
`;

const TitleModalContent = ({ 
  clientInput,
  clientFilter,
  isShowClientList,
  clientList,
  selectClient,
  clientIDDefault,
  dataWarehouses,
  tranzitID,
  defaultArizaTranzit,
  setTranzitID,
  externalPalletNumber,
  onExternalPalletNumberChange,
  isDisabled,
  closeFunc
}) => {
  const [t] = useTranslation(['controllPallet', 'buttons']);

  return (
    <ContentWrapper>
    <BodyWrapper>
      

      <SearchBlockWithTitle
        title={t('controllPallet_chooseCustomer')}
      >
        <SearchFromTheList
          input={clientInput}
          searchFunc={clientFilter}
          placeHolder={t('controllPallet_chooseCustomer')}
          fieldClietns={isShowClientList}
          list={clientList}
          itemDisplayName={'Customer_Name'}
          nameIdElement={'CustomerID'}
          selectFunc={selectClient}
          isOpenList={isShowClientList}
          size={'full'}
          disabled={!!clientIDDefault || isDisabled}
        />
      </SearchBlockWithTitle>
      
      <SearchBlockWithTitle
        title={'בחר מחסן'}
      >
        <SearchWarehouse
          list={dataWarehouses || []}
          defaultID={tranzitID || defaultArizaTranzit}
          setWarehouseID={setTranzitID}
          isOpenList={!tranzitID}
          disabled={isDisabled}
        />
      </SearchBlockWithTitle>
      <SearchBlockWithTitle
        title={t('controllPallet_externalPalletNumber')}
      >
        <SearchInput
          input={externalPalletNumber}
          setInput={onExternalPalletNumberChange}
          value={t('controllPallet_externalPalletNumber')}
          disabled={isDisabled}
          type="number"
          size="full"
        />
      </SearchBlockWithTitle>
    </BodyWrapper>
      
      <ButtonWrapper>
        <ControlButton
          handleClick={closeFunc}
          lable={t('buttons:save')}
        />
      </ButtonWrapper>
    </ContentWrapper>
  );
};

export default TitleModalContent; 